import { Component, OnInit } from '@angular/core';
import { TemplateService } from '../../shared/services/template.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  searchModel: string;
  isCollapse: boolean;
  isOpen: boolean;
  searchActived = false;
  me: any;

  constructor(
    private tplSvc: TemplateService,
    private router: Router,
    private _location: Location,
  ) {}

  ngOnInit(): void {
    this.tplSvc.isSideNavCollapseChanges.subscribe(
      (isCollapse) => (this.isCollapse = isCollapse),
    );
    this.tplSvc.isSidePanelOpenChanges.subscribe(
      (isOpen) => (this.isOpen = isOpen),
    );
  }

  toggleSideNavCollapse() {
    this.isCollapse = !this.isCollapse;
    this.tplSvc.toggleSideNavCollapse(this.isCollapse);
  }

  toggleSidePanelOpen() {
    this.isOpen = !this.isOpen;
    this.tplSvc.toggleSidePanelOpen(this.isOpen);
  }

  toggleSearch() {
    this.searchActived = !this.searchActived;
    console.log(this.searchActived);
  }
  backClick(): void {
    this._location.back();
  }
}
